import client from 'FrontendJsAssets/common/client'

const lang = document.querySelector('html').getAttribute('lang')
const $ = window.jQuery;
let generalError
let productRatingLocale

import(`../locale/${lang}`).then((module) => {
    generalError = module.GeneralError
    productRatingLocale = module.ProductRating
})

export function buildStars() {
    if (!document.querySelector('.js-stars')) {
        return
    }

    import(`Lib/jquery/jquery.star-rating-svg`).then(() => {
        for (const starElement of document.querySelectorAll('.js-stars')) {
            if (starElement.classList.contains('is-loaded')) {
                continue
            }

            const elData = starElement.dataset
            const updateInput = elData.updateInput
            const emptyColor = elData.emptyColor || '#DDDDDD'
            const readOnly = !updateInput

            let settings = {
                totalStars: elData.totalStars || 5,
                starSize: elData.size || 20,
                initialRating: elData.stars * 5 / 100,
                readOnly: readOnly,
                emptyColor: emptyColor,
                hoverColor: elData.activeColor || '#111111',
                activeColor: elData.activeColor || '#111111',
                ratedColor: '#a55e23',
                strokeColor: 'transparent',
                useGradient: false,
                disableAfterRate: false
            }

            if (updateInput) {
                settings.callback = (currentRating, el) => {
                    document.querySelector(updateInput).value = currentRating
                }
            }

            $(starElement).starRating(settings)
 
            const placeholder = document.querySelector('.js-stars-placeholder')

            if (placeholder) {
                placeholder.style.display = 'none'
                starElement.style.display = 'flex'
            }

            starElement.classList.add('is-loaded')
        }
    })
}

export function initRatingForm() {
    $('.js-product-rating-form').validate({
        submitHandler: function(form) {
            const imagesHiddenInputEl = form.querySelector('.js-rating-upload-value-input')

            if (
                imagesHiddenInputEl.asyncImageUploader
                && imagesHiddenInputEl.asyncImageUploader.isUploading
            ) {
                Eshop.tippyAlert($(form).find('[type="submit"]')[0], productRatingLocale.cantSendBecauseUploadInProgress, {
                    theme: 'warning',
                    zIndex: 1060,
                })

                return
            }

            $(form).find('[type="submit"]').addClass('is-loading');

            var formData = new FormData(form);

            client.post($(form).attr('action'), formData)
                .then((response) => {
                    const data = response.data

                    $('.js-product-rating-message').slideUp(100);

                    if (data.status) {
                        $('.js-product-rating-form').slideUp();
                    }

                    if (data.status) {
                        rEvent.dispatch('Custom.productRatingFormSubmit', {form})
                    }

                    $('.js-product-rating-message')
                        .toggleClass('c-msg--error', !data.status)
                        .toggleClass('c-msg--success', data.status)
                        .text(data.message)
                        .slideDown();

                        $(form).closest('.modal').scrollTop(0);
                    })
                .catch((error) => {
                    $('.js-product-rating-message')
                        .addClass('c-msg--error')
                        .removeClass('c-msg--success')
                        .text(generalError)
                        .slideDown();
                })
                .finally(() => {
                    rEvent.dispatch('Recaptcha.execute');
                    $(form).find('[type="submit"]').removeClass('is-loading');
                })
        }
    });
}

export function buildArticleStars() {
    if (!document.querySelector('.js-article-stars')) {
        return
    }

    import(`Lib/jquery/jquery.star-rating-svg`).then(() => {
        for (const starElement of document.querySelectorAll('.js-article-stars')) {
            if (starElement.classList.contains('is-loaded')) {
                continue
            }

            const elData = starElement.dataset
            const updateInput = elData.updateInput
            const emptyColor = elData.emptyColor || '#DDDDDD'
            const readOnly = !updateInput

            let settings = {
                totalStars: elData.totalStars || 5,
                starSize: elData.size || 20,
                initialRating: elData.stars * 5 / 100,
                readOnly: readOnly,
                emptyColor: emptyColor,
                hoverColor: '#cf762c',
                activeColor: '#cf762c',
                ratedColor: '#a55e23',
                strokeColor: 'transparent',
                useGradient: false,
                disableAfterRate: false,
                useFullStars: true,
            }

            settings.callback = (currentRating, el) => {
                document.querySelector(updateInput).value = currentRating
                postArticleRating(currentRating)
            }

            $(starElement).starRating(settings)
            starElement.classList.add('is-loaded')
        }
    })
}

async function postArticleRating(ratingVal) {
    let articleId = document.querySelector('.js-article').dataset.id;

    const element = document.querySelector('.js-article-rating-stars');

    const captchaToken = await getRecaptchaToken('dublez_warranty_upload')

    client.post('/custom-article-rating', {
            id: articleId,
            ratingValue: ratingVal,
            captchaToken: captchaToken
        })
        .then((response) => {
            const data = response.data

            document.querySelector('.js-rating-avg').innerHTML = data.rating_avg
            document.querySelector('.js-rating-count').innerHTML = data.rating_count

            document.querySelectorAll('.js-article-stars').forEach(starElement => {
                starElement.dataset.stars = data.rating_avg * 20
                $(starElement).starRating('setRating', data.rating_avg)
            });

            rEvent.dispatch('Custom.articleRatingFormSubmit', ratingVal)

            buildArticleStars()

            Eshop.tippyAlert(element, data.message, {
                theme: 'success',
            }, 300);
        })
        .catch((error) => {
            Eshop.tippyAlert(element, generalError, {
                theme: 'error',
            }, 300)
        })
}